import { useEffect, useState } from "react";
import axios from "axios";
import { NOOR } from "@/constants/testIds/noor";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Always-visible primary fragments + secondary fragments hidden under .edition-secondary
// on mobile (see App.css media rule).
export default function EditionCounter() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/edition/status`)
      .then((res) => {
        if (alive) setStatus(res.data);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!status) {
    return (
      <div className="edition-bar" data-testid={NOOR.editionCounter}>
        <span>Edition Nº 001</span>
        <span className="dot edition-secondary">·</span>
        <span className="edition-secondary">1000 bottles</span>
        <span className="dot edition-secondary">·</span>
        <span className="edition-secondary">cellared in Jalisco</span>
      </div>
    );
  }

  return (
    <div className="edition-bar" data-testid={NOOR.editionCounter}>
      <span>{status.name}</span>
      <span className="dot">·</span>
      <span>
        <span className="remaining" data-testid={NOOR.editionRemaining}>{status.remaining}</span>
        <span className="edition-secondary-inline">
          <span className="edition-spacer" />
          of <span data-testid={NOOR.editionTotal}>{status.total}</span>
        </span>
        <span className="edition-spacer" />
        remain
      </span>
      <span className="dot edition-secondary">·</span>
      <span className="edition-secondary">cellared in Jalisco</span>
    </div>
  );
}
